import { isReferralPartner } from '../constants/referralPartners'

const STORAGE_KEY = 'referralPartner'
const TTL_MS = 7 * 24 * 60 * 60 * 1000

// A doctor may land on a partner page, browse elsewhere, and only sign up days later, so the
// marker has to outlive the full-page hop to /auth and that delay. It is read once, when the
// signup form is submitted (getRegisterMetadata below); from then on the user record carries
// the partner. localStorage mirrors the existing `publicProject` flow; the timestamp adds the
// one-week expiry that flow lacks.
const ReferralPartner = {
  remember(slug) {
    if (!isReferralPartner(slug)) return
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ partner: slug, savedAt: Date.now() })
      )
    } catch {
      // Storage unavailable (private browsing): attribution is best-effort, never fatal.
    }
  },

  read() {
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY))
      if (!stored || !isReferralPartner(stored.partner)) return null
      if (Date.now() - stored.savedAt > TTL_MS) {
        ReferralPartner.clear()
        return null
      }
      return stored.partner
    } catch {
      return null
    }
  },

  clear() {
    try {
      localStorage.removeItem(STORAGE_KEY)
    } catch {
      // no-op
    }
  },
}

// Handed to AuthProvider so the partner goes out with the signup request and is stored on the
// user. Signup happens in the tab the partner landing page opened; the expert profile is often
// finished in the tab the verification email opens, where this storage may not exist.
export const getRegisterMetadata = () => {
  const partner = ReferralPartner.read()
  return partner ? { referredByPartner: partner } : undefined
}

export default ReferralPartner
